/*
 * 创建基础axios实例
 * @Author: Li Chunqiang
 * @Date: 2020-07-18 19:51:44
 * @Last Modified by: Li Chunqiang
 * @Last Modified time: 2020-07-21 09:39:54
 */
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

export default function createAxios(config: AxiosRequestConfig): AxiosInstance {
    const axiosInstance = axios.create({
        timeout: 30 * 1000,
        ...config,
    });
    return axiosInstance;
}
